import { render, staticRenderFns } from "./BlacklistUsers.vue?vue&type=template&id=603a0dc4&"
import script from "@/scripts/users/blacklistUsers.js?vue&type=script&lang=js&"
export * from "@/scripts/users/blacklistUsers.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports